import { Button, Typography } from '@breetometer/components';
import { CheckmarkIcon, MeterTypeIcon, UnavailableIcon } from 'BreetAssets';

import type { IBeneficiaryCard } from '../BeneficiaryCard.helpers';

const DefaultCard = ({
	name,
	bankName,
	accountNumber,
	onClick,
	selected,
	isAutoSettlement,
	multiple,
	disabled,
}: IBeneficiaryCard) => (
	<Button
		variant='native'
		className={`beneficiary cursor_pointer bg-primary-500 ${multiple ? ' border-bottom-primary-400 last-child' : 'border-dark-navy'}`}
		onClick={onClick}
		type='button'
	>
		<div className='beneficiary_details'>
			<div className='beneficiary_details_header'>
				<Typography
					as='h6'
					className='color-neutral-50'
				>
					{name}
				</Typography>
				{disabled ? <UnavailableIcon className='svg-dark' /> : null}
			</div>
			<Typography className='color-primary-50'>
				{bankName}&nbsp;&nbsp;
				<Typography
					as='span'
					className='separator color-primary-300'
				>
					|
				</Typography>
				&nbsp;&nbsp;{accountNumber}
			</Typography>
		</div>
		{!selected && isAutoSettlement ? (
			<div className='isautosettlement'>
				<CheckmarkIcon variant='dark' />
				<Typography as='p'>Automatic Settlement</Typography>
			</div>
		) : (
			<MeterTypeIcon
				className='beneficiary_selecticon'
				selected={selected}
			/>
		)}
	</Button>
);

export default DefaultCard;
